import Rutas from 'vue-routes-generator'

import Login from './components/login/login'
import PasswordRestore from './components/password-restore/password-restore.vue'
// import Dashboard from './components/dashboard/dashboard.vue'
import Muro from '../../muro/vue/main'
import PanelControl from './components/panel-control/panel.vue'
import PanelControlMenu from './components/panel-control/menu.vue'

export default {
	install: Vue => {
		Rutas.route('/password-restore', {
			name: 'Restaurar contraseña',
			component: PasswordRestore
		})
		Rutas.route('/main').child('', {
			name: 'Inicio',
			component: Muro
		})
		Rutas.route('/main').child('panel-control', {
			component: PanelControl
		})
		Rutas.route('/main').child('panel-control').child('', {
			name: 'Panel de control',
			component: PanelControlMenu
		})

		Rutas.route('/login', {
			name: 'Login',
			component: Login
		})

		Rutas.route('/password-restore/:idUsuario/:token', {
			component: PasswordRestore,
			name: 'Restaurar contraseña'
		})

		Vue.prototype.round = (numero, precision) => {
			if (typeof numero !== 'number') {
				return NaN
			}

			precision = (typeof precision !== 'number' || precision < 0) ? 2 : precision

			let nuevo = parseInt(Math.round(numero * Math.pow(10, precision)))
			return nuevo / Math.pow(10, precision)
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/index.js